import { z } from 'zod';
import { isCpfCnpjValid } from '@/lib/masks';

export const loginSchema = z.object({
  email: z.string().email('Informe um email válido'),
  senha: z.string().min(1, 'Informe sua senha'),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export const registerSchema = z
  .object({
    nome: z.string().min(1, 'Informe seu nome'),
    email: z.string().email('Informe um email válido'),
    cpf_cnpj: z
      .string()
      .refine((v) => isCpfCnpjValid(v), 'Informe um CPF ou CNPJ válido'),
    telefone: z.string().min(10, 'Informe um telefone válido'),
    senha: z.string().min(6, 'A senha deve ter pelo menos 6 caracteres'),
    confirmacao_senha: z.string().min(1, 'Confirme sua senha'),
  })
  .refine((data) => data.senha === data.confirmacao_senha, {
    message: 'As senhas não coincidem',
    path: ['confirmacao_senha'],
  });

export type RegisterFormData = z.infer<typeof registerSchema>;

export const passwordSchema = z
  .object({
    senha: z
      .string()
      .min(6, 'A senha deve ter pelo menos 6 caracteres')
      .regex(/[0-9]/, 'A senha deve conter pelo menos um número')
      .regex(/[A-Z]/, 'A senha deve conter pelo menos uma letra maiúscula')
      .regex(/[a-z]/, 'A senha deve conter pelo menos uma letra minúscula')
      .regex(
        /[!@#$%^&*(),.?":{}|<>]/,
        'A senha deve conter pelo menos um caractere especial'
      ),
    confirmacao_senha: z.string().min(1, 'Confirme sua senha'),
  })
  .refine((data) => data.senha === data.confirmacao_senha, {
    message: 'As senhas não coincidem',
    path: ['confirmacao_senha'],
  });

export type PasswordFormData = z.infer<typeof passwordSchema>;

export const verifyCodeSchema = z.object({
  email: z.string().email('Informe um email válido'),
  codigo: z.string().length(6, 'O código deve ter 6 dígitos').regex(/^\d{6}$/, 'O código deve conter apenas números'),
});

export type VerifyCodeFormData = z.infer<typeof verifyCodeSchema>;
